export default "__VITE_ASSET__D0kUzy$O__"